"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BasisTheoryApplicationTemplates = void 0;

var _common = require("./../common");

var _service = require("./../service");

var _CrudBuilder = require("./../service/CrudBuilder");

const BasisTheoryApplicationTemplates = new _CrudBuilder.CrudBuilder(class BasisTheoryApplicationTemplates extends _service.BasisTheoryService {
  list(options) {
    return this.client.get('/', (0, _common.createRequestConfig)(options)).then(_common.dataExtractor);
  }

}).retrieve().build();
exports.BasisTheoryApplicationTemplates = BasisTheoryApplicationTemplates;